import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Hero from "./components/Hero";
import WasIst from "./components/WasIst";
import Inhalte from "./components/Inhalte";
import Voraussetzungen from "./components/Voraussetzungen";
import Ablauf from "./components/Ablauf";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import Impressum from "./components/Impressum";
import Datenschutz from "./components/Datenschutz";
import AGB from "./components/AGB";
import Widerruf from "./components/Widerruf";

const Landing = () => {
  return (
    <div data-testid="landing-page" className="bg-[#FAFAF7] text-[#1A1A1F]">
      <Header />
      <main>
        <Hero />
        <WasIst />
        <Inhalte />
        <Voraussetzungen />
        <Ablauf />
        <Faq />
      </main>
      <Footer />
      <Toaster
        position="top-center"
        theme="light"
        toastOptions={{
          style: {
            background: "rgba(255,255,255,0.95)",
            color: "#1A1A1F",
            border: "1px solid rgba(26,26,31,0.08)",
            backdropFilter: "blur(16px)",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/widerruf" element={<Widerruf />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
